<script>
export default {
  props: {
    order: { type: Object }
  },
  data: () => ({
    loading: true,
    transition: 'scale-transition',
    error: false
  }),
  created() {
    this.loading = false
      }
}
</script>
<template>
  <v-skeleton-loader
    :loading="loading"
    :transition="transition"
    height="94"
    type="article" >
    <div>
      <v-row v-if="error">
        <v-col cols="md-12" class="center-text">
          <v-container fluid>
            <v-row>
              <v-col cols="6" class="mx-auto">
                <v-alert type="error">
                  {{ $t('component.checkout.checkoutPending.loading.error') }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <v-container fluid>
            <v-row>
              <v-col cols="4" class="mx-auto">
                <v-card>
                  <v-card-text>
                    <h1 class="pl-0 headline text-center primary--text">
                      {{ $t('component.checkout.checkoutPending.header') }}
                    </h1>
                    <br />
                    <v-alert outlined text class="primary--text">
                      <span
                        v-html="$t('component.checkout.checkoutPending.content')">
                      </span>
                      <br /><br />
                    </v-alert>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </div>
  </v-skeleton-loader>
</template>
